import { useCallback } from 'react'
import { useParams } from 'react-router'
import { ModalCreateEditBase } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../../../../forms/TwinForm/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getVariants } from '../../../../../../../../../../utils/reducers/getters'

interface CreateCustomVariantsStep1Props { 
    onSubmit: OnSubmit
}

export const CreateCustomVariantsStep1: React.FC<CreateCustomVariantsStep1Props> = ({ onSubmit }) => {
    const { id } = useParams()
    const { beforeSubmit } = useCreateCustomVariantsStep1Logic()
    const { t } = useTwinTranslation()
    const variants = getVariants() || {}
    const fields: FormRender = [
        {
            cols: 1,
            title: t('selectTheCombinationsYouWantGenerate', 'Selecciona las combinaciones que quieres generar'),
            elements: [
                {
                    component: 'InputHidden',
                    name: 'ProductId',
                    value: id
                }
            ]
        }
    ]
    for (const key in variants) {
        const variant = variants[key]
        fields[0].elements.push(
            {
                component: 'MultipleCheckboxSelector',
                items: variant.values,
                name: 'VariantGroupsId-' + key,
                subtitles: {
                    subtitleOptions: t('variantsForSelect', 'Variantes para seleccionar') + ' - ' + variant.name,
                    subtitleSelectedOptions: t('variantsSelected', 'Variantes seleccionadas') + ' - ' + variant.name,
                }
            },
        )
    }
    return (
        <ModalCreateEditBase url={'/api/app/product/getAllCombinationsByValues'} onSubmit={onSubmit} translations={{ title: t('customGeneration', 'Generación personalizada'), button: t('generate', 'Generar') }} haveButtonPermissions={true} fields={fields} setOpened={() => { }} triggerSuccess={false} beforeSubmit={beforeSubmit} />
    )
}

const useCreateCustomVariantsStep1Logic = () => {
    const beforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        const VariantValuesCustom: any = {}
        for (const key in vals) {
            const item = vals[key]
            if (key.includes('VariantGroupsId-') && item) {
                const key2 = key.split('VariantGroupsId-')[1]
                VariantValuesCustom[key2] = item.split(';')
            }
        }
        vals.VariantValuesCustom = VariantValuesCustom
        return true
    }, [])

    return { beforeSubmit }
}